@if (categoriaServicos().length) {
  <section class="categoria-servicos" aria-labelledby="categoria-servicos-titulo">
    <h2 class="categoria-servicos-titulo" id="categoria-servicos-titulo">Categorias de serviços</h2>

    <div class="categoria-servicos-grade">
      @for (categoria of categoriaServicos(); track categoria.id) {
        <!-- Caminho em texto: no array de comandos, a barra de `servicos/saude` sairia `%2F`. -->
        <a
          class="categoria-servicos-card"
          [attr.data-categoria-servicos-cor]="categoria.cor"
          [routerLink]="'/' + categoria.rotaPagina"
        >
          <app-icone-servico
            class="categoria-servicos-card-icone"
            [icone]="categoria.icone"
          ></app-icone-servico>

          <div class="categoria-servicos-card-conteudo">
            <h3 class="categoria-servicos-card-titulo">{{ categoria.titulo }}</h3>
            <p class="categoria-servicos-card-descricao">{{ categoria.descricao }}</p>
          </div>

          <i-lucide
            class="categoria-servicos-card-info"
            name="info"
            size="20"
            aria-hidden="true"
          ></i-lucide>
        </a>
      }
    </div>

    <div class="categoria-servicos-acoes">
      <a class="categoria-servicos-botao" routerLink="/categorias-servicos">
        Ver mais serviços
        <i-lucide name="chevron-right" size="18" aria-hidden="true"></i-lucide>
      </a>
    </div>
  </section>
}
